interface FormErrorProps {
  error: string | string[] | undefined
  className?: string
}

/**
 * Displays form validation errors.
 * Handles both string and string[] error formats from Inertia.
 */
export function FormError({ error, className }: FormErrorProps) {
  if (!error) return null

  const message = Array.isArray(error) ? error[0] : error

  if (!message) return null

  return (
    <p className={className ?? "text-sm text-destructive"}>
      {message}
    </p>
  )
}
